import launcherProviders from './launcher_providers';

const CARD_PROVIDERS = {
    AD_EXPERIMENTS: 'ad_experiment',
    AD_RELEVANCE: 'ad_relevance',
    ADD_NEGATIVE_WORD_FROM_SEARCH_TERM_SUGGESTION:
        'add_negative_word_from_search_term_suggestion',
    ADS_IN_EXCESS: 'double_kill_ads',
    ADS_WITH_OVER_90_DAYS: 'ads_with_over_90_days',
    ADS_WITH_OVER_180_DAYS: 'ads_with_over_180_days',
    ADS_WITH_OVER_1_YEAR: 'ads_with_over_1_year',
    ADSET_GRADER: 'adset_grader',
    AD_CREATION: 'ad_creation',
    BAD_PLACEMENT_SITE_PERFORMACE: 'bad_performance_site_placement',
    BID_MODIFIER: 'bid_modifier',
    BRAND_DAMAGE_ALERT: 'brand_damage_alert',
    CONVERSION_TRACKING: 'conversion_tracking',
    DISPLAY_FRAUD_FINDER: 'display_fraud_finder',
    EXPECTED_CTR: 'expected_ctr',
    EXTENSIONS_WARNING: 'extensions',
    FACEBOOK_CREATIVE_EXPERIMENT: 'facebook_creative_experiment',
    KBA: 'kba',
    MOBILE_APPS_PERFORMANCE: 'mobile_apps_performance',
    QUALITY_METRIC_DROP: 'quality_metric_drop',
    QUALITY_METRIC_LOW: 'quality_metric_low',
    SEARCH_TERM_SUGGESTIONS: 'search_term_suggestions',
    SEARCH_TERM_CHECK: 'search_term_check',
    SMART_FUNNEL_CAMPAIGN: 'smart_funnel_campaign',
    SMART_FUNNEL_CONFIGURATION: 'smart_funnel_configuration',
    SPECIFIC_CAMPAIGN: 'specific_campaign',
    TEMPLATE: 'template',
    UPTIME_MONITOR: 'uptime_monitor',
    ONE_CLICK_INSIGHT: 'one_click_insight',
    BID_CEILING: 'bid_ceiling',
    ...launcherProviders,
};

const TEMPLATE_CARDS_PROVIDERS = {
    TEMPLATE_BID_MODIFIER_AGE: 'template_bid_modifier_age',
    TEMPLATE_BID_MODIFIER_DEVICE: 'template_bid_modifier_device',
    TEMPLATE_BID_MODIFIER_GENDER: 'template_bid_modifier_gender',
    TEMPLATE_SUGGESTION: 'template_suggestion',
};

const AUTOMATION_PROVIDERS = {
    GGL_BID_STRATEGY_MODIFIER: 'ggl-bid-strategy-modifier',
    GGL_LIMITED_CAMPAIGNS_BUDGET: 'GGL_LIMITED_CAMPAIGNS_BUDGET',
    FB_BID_STRATEGY_MODIFIER: 'fb-bid-strategy-modifier',
    GGL_BUDGET_MODIFIER: 'ggl-budget-modifier',
    FB_BUDGET_MODIFIER: 'fb-budget-modifier',
    GGL_LIMITED_CAMPAIGNS_RANK: 'GGL_LIMITED_CAMPAIGNS_RANK',
};

export {
    AUTOMATION_PROVIDERS,
    CARD_PROVIDERS,
    TEMPLATE_CARDS_PROVIDERS,
};
